import { DateTime, Duration } from 'luxon'
import { range, toInteger } from 'lodash-es'
import I18n from './I18n'

DateTime.local().setLocale(I18n.locale)

export function getCopyrightYears (): number[] {
  const threeYearsAhead: number = toInteger(DateTime.local().plus({ years: 3 })
    .toFormat('yyyy'))
  return range(threeYearsAhead, 1969)
}

export function getCreditCardExpirationYears (): number[] {
  const tenYearsAhead: number = toInteger(DateTime.local().plus({ years: 10 })
    .toFormat('yyyy'))
  const thisYear: number = toInteger(DateTime.fromMillis(Date.now()).toFormat('yyyy'))
  return range(thisYear, tenYearsAhead)
}

export const CREDIT_CARD_EXPIRATION_MONTHS: number[] = range(1, 13)

export const formatMediaTime = (seconds: number): string => DateTime.fromMillis(Duration.fromObject({ seconds }).as('milliseconds')).toFormat('mm:ss')

export const monthsAgo = (months: number): string => DateTime.local().minus({ months })
  .toFormat('yyyy-MM-dd')

export const prettyDateRange = (start: string, end: string): string => `${DateTime.fromISO(start).toLocaleString(DateTime.DATE_SHORT)} - ${DateTime.fromISO(end).toLocaleString(DateTime.DATE_SHORT)}`

export const prettyDateRangeMonths = (start: string, end: string): string => `${DateTime.fromISO(start).toFormat('MM/yyyy')} - ${DateTime.fromISO(end).toFormat('MM/yyyy')}`
